<router-outlet *ngIf="!isIframe"></router-outlet>
<!-- <app-report-problem></app-report-problem> -->
<app-candidate-floating-chatbot></app-candidate-floating-chatbot>
